import { useEffect, useState } from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { setLevelVerifiedLocal } from '../lib/levelVerified';

// Fetch current level / verification for a list of participants (coach views).
export const useParticipantLevels = (API, userIds) => {
  const key = (userIds || []).filter(Boolean).join(',');
  const [map, setMap] = useState({});
  useEffect(() => {
    if (!key) { setMap({}); return; }
    API.post('/level-verified/levels', { ids: key.split(',') }).then(({ data }) => setMap(data || {})).catch(() => setMap({}));
  }, [API, key]);
  return [map, setMap];
};

// Level chip + green check toggle ("level verified by our coach").
export const LevelVerifyControl = ({ userId, info, API, L, onChanged, showLevel = true }) => {
  const [busy, setBusy] = useState(false);
  if (!userId) return null;
  const verified = !!info?.level_verified;
  const toggle = async () => {
    setBusy(true);
    try {
      await API.put(`/users/${userId}/level-verified`, { verified: !verified });
      setLevelVerifiedLocal(userId, !verified);
      onChanged?.(!verified);
      toast.success(!verified ? L('Level marked as verified', 'Level als verifiziert markiert') : L('Verification removed', 'Verifizierung entfernt'));
    } catch (e) {
      toast.error(e.response?.data?.detail || L('Error', 'Fehler'));
    } finally { setBusy(false); }
  };
  return (
    <span className="inline-flex items-center gap-1.5">
      {showLevel && <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 font-bold" data-testid={`participant-level-${userId}`}>
        Level {info?.player_level != null ? Number(info.player_level).toFixed(1) : '–'}
      </span>}
      <button type="button" onClick={toggle} disabled={busy}
        title={verified ? L('Level verified — click to remove', 'Level verifiziert — klicken zum Entfernen') : L('Mark level as verified', 'Level als verifiziert markieren')}
        className={`inline-flex items-center gap-1 text-[10px] font-bold px-1.5 py-0.5 rounded border transition-colors ${verified ? 'bg-[#22c55e] border-[#22c55e] text-white' : 'bg-white border-slate-300 text-slate-400 hover:border-[#22c55e] hover:text-[#16a34a]'}`}
        data-testid={`level-verify-toggle-${userId}`}>
        <CheckCircle size={12} weight="fill" /> {verified ? L('Verified', 'Verifiziert') : L('Verify', 'Verifizieren')}
      </button>
    </span>
  );
};
